export default __webpack_public_path__ + "static/media/selenium.8acd00a9.png";